import { render, staticRenderFns } from "./Persontypes.vue?vue&type=template&id=fdd2c640&"
import script from "./Persontypes.vue?vue&type=script&lang=js&"
export * from "./Persontypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports